import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_match_type_value = _resolveComponent("match-type-value");
  const _component_MatchTypeFilterBody = _resolveComponent("MatchTypeFilterBody");
  const _component_FilterItem = _resolveComponent("FilterItem");
  return _openBlock(), _createBlock(_component_FilterItem, {
    id: "match-types",
    ref: "matchTypeFilterItem",
    selectedCount: $props.match_types?.filterState?.selectedCount,
    selectedTitle: $options.getMatchTypeSelectedTitle,
    onClearAll: $options.onClear,
    onApply: $options.onApply,
    onHidden: $options.onHidden
  }, {
    title: _withCtx(() => [_createVNode(_component_match_type_value, {
      name: $options.getMatchTypeTitle,
      type: $options.getMatchType?.type
    }, null, 8, ["name", "type"])]),
    body: _withCtx(() => [_createVNode(_component_MatchTypeFilterBody, {
      title: "Match type",
      selected: $props.match_types?.filterState?.selected,
      isModified: $props.match_types.isModified,
      pendingChanges: $props.match_types.pendingChanges,
      isSearching: $props.match_types.isSearching,
      keyword: $props.match_types.keyword,
      list: $props.match_types.displayList,
      onClear: $options.onClear,
      onDiscard: $options.onDiscard,
      onRestoreSearch: $options.onRestoreSearch,
      onSelect: $options.onSelect,
      onSelectOnly: $options.onSelectOnly,
      onDeselect: $options.onDeSelect,
      onApply: $options.onApply,
      onSearch: $options.onSearch,
      onHidden: $options.onHidden,
      onCloseDropdown: $options.onClose
    }, null, 8, ["selected", "isModified", "pendingChanges", "isSearching", "keyword", "list", "onClear", "onDiscard", "onRestoreSearch", "onSelect", "onSelectOnly", "onDeselect", "onApply", "onSearch", "onHidden", "onCloseDropdown"])]),
    _: 1
  }, 8, ["selectedCount", "selectedTitle", "onClearAll", "onApply", "onHidden"]);
}